import { useTranslation } from 'contexts/Localization'
import { Text } from 'vvs-uikit'
import { ResponsiveGrid } from './styles'

export const LeaderboardTableHeader = () => {
  const { t } = useTranslation()
  return (
    <ResponsiveGrid mb={1} mt={3}>
      <Text color="darkestNightBlue" fontSize="11px" textAlign="center">
        {t('Rank')}
      </Text>
      <Text color="darkestNightBlue" fontSize="11px">
        {t('ID')}
      </Text>
      <Text color="darkestNightBlue" fontSize="11px">
        {t('Boost')}
      </Text>
      <Text color="darkestNightBlue" fontSize="11px">
        {t('Exp Earned')}
      </Text>
    </ResponsiveGrid>
  )
}
